<template>
  <div class="form-group-simple digital-signature"
  :class="{
    'form-group-simple--completed': completed,
    'form-group-simple--error': errors.has('signature')}">
    <label :for="id" v-if="label">{{ label }}</label>
    <label v-if="desc" class="description">{{ desc }}</label>
    <VueSignaturePad ref="signaturePad"
    class="digital-signature__signature-canvas"
    :name="name"
    :id="id"/>
    <div class="row grid-margin grid-justify-content-left digital-signature__actions">
      <div class="col-xs-12 col-sm-6">
        <a class="undoSign" @click="undoSignature">Handtekening opnieuw zetten</a>
      </div>
      <div class="col-xs-12 col-sm-6">
        <v-button lg secondary nowrap class="save-sign" @click.native.prevent="saveSignature">Handtekening opslaan</v-button>
      </div>
    </div>
    <div class="form-group-simple__details">
      <div class="form-group-simple__messages">
        <div class="form-group-simple__error" v-show="errors.has('signature')">{{ errors.first('signature') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
import VueSignaturePad from 'vue-signature-pad'

export default {
  name: 'v-input-digital-signature',
  components: {
    VueSignaturePad
  },
  props: {
    name: {
      default: 'signature',
      type: String
    },
    label: {
      default: '',
      type: String
    },
    id: {
      default: '',
      type: String
    },
    desc: {
      default: null,
      type: String
    }
  },
  data () {
    return {
      errors: '',
      completed: false
    }
  },
  created () {
    this.validator = new Validator()
    this.validator.attach(
      'signature',
      'required',
      { alias: 'Signature' })
    this.$set(this, 'errors', this.validator.errors)
  },
  methods: {
    // Function to validate the signature
    validate () {
      this.validator.validate('signature', this.signature)
    },
    // Function to save the signature, we get the image in base64 format
    saveSignature () {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      if (data) {
        this.$emit('saveSignature', isEmpty, data)
      }
    },
    // Function to undo the change in the signature pad
    undoSignature () {
      this.$refs.signaturePad.undoSignature()
      this.$emit('undoSignature')
    }
  }
}
</script>

<style lang="scss" scoped>
.digital-signature {
  width: 500px;
  .description {
    font-size: 15px;
    font-weight: normal;
  }
  &__signature-canvas {
    min-height: 300px;
    margin-top: 10px;
    border: solid 1px $grayish-darkish;
    background-color: $white;
    background-size: 15px 15px;
    background-image: linear-gradient(to right, $black -3px, transparent 1px), linear-gradient(to bottom, $black -3px, transparent 1px);
  }
  &__actions {
    margin-top: 10px;
    .btn {
      background-color: $teal-darkest;
    }
    .undoSign {
      font-size: 16px;
      line-height: 1.5rem;
      color: $teal-darkest;
      cursor: pointer;
      text-decoration: underline;
      margin-top: 0.75rem;
    }
  }
}
</style>